import { rootApi } from "../../api/rootApi";

const bankDetailHeaders = (params) => ({
  Authorization: "Bearer " + params.token,
  slug: params.tenant_id,
});

export const appUsersBankApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getBankDetailByAppUserId: builder.mutation({
      query: (params) => {
        const query = params.includeDeleted ? "?includeDeleted=true" : "";
        return {
          method: "GET",
          url: `/app/bankDetail/${params.id}${query}`,
          headers: bankDetailHeaders(params),
        };
      },
    }),
    getAllBankDetail: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/bankDetail/`,
          headers: bankDetailHeaders(params),
          body: params.body,
        };
      },
    }),
    addBankDetail: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/bankDetail/add`,
          headers: bankDetailHeaders(params),
          body: params.body,
        };
      },
    }),
    updateBankDetailStatus: builder.mutation({
      query: (params) => {
        return {
          method: "PATCH",
          url: `/app/bankDetail/${params.id}`,
          headers: bankDetailHeaders(params),
          body: params.body,
        };
      },
    }),
    deleteBankDetail: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/app/bankDetail/${params.id}`,
          headers: bankDetailHeaders(params),
        };
      },
    }),
  }),
});

export const {
  useGetBankDetailByAppUserIdMutation,
  useGetAllBankDetailMutation,
  useAddBankDetailMutation,
  useUpdateBankDetailStatusMutation,
  useDeleteBankDetailMutation,
} = appUsersBankApi;
